
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import request from 'superagent'
import Animation from './Animation'
import { FlexItem, FlexGrid } from './flexgrid'
import Overlay from './Overlay'
import Space from './Space'
import { Display1, Body1 } from './typography'
import { color } from 'ui/variables'
import Check from './icons/check'
import Close from './icons/close'
import PlanCard from './PlanCard'
import Link from './Link'
import './UpgradePrompt.css'

class UpgradePrompt extends Component {
  constructor () {
    super()

    this.state = {
      loading: false
    }
  }
  render () {
    const {
      headline, subhead, items, plans, workspace,
      planOverrides, hasOverlay, onPlanClick, onClose
    } = this.props

    return (
      <Overlay visible transparent={!hasOverlay}>
        <div className='UpgradePrompt'>
          <div className='UpgradePrompt-overlay' onClick={onClose} />
          <Animation type='fadeIn'>
            <FlexGrid className='UpgradePrompt-container'>
              <FlexItem width='290'>
                <div className='UpgradePrompt-sidebar'>
                  <div>
                    <Display1 color={color.white}>{headline}</Display1>
                    <Space value={18} />
                    <Body1 color={color.white}>{subhead}</Body1>
                    <Space value={14} />
                    <ul>
                      {items.map((item, index) => (
                        <li className='UpgradePrompt-item' key={`__upgradeprompt_item_${index}`}>
                          <Check />
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <Link href='/pricing' target='_blank' rel='external' icon='rightArrow'>
                      Learn more on the Pricing Page
                    </Link>
                  </div>
                </div>
              </FlexItem>
              <FlexItem className='UpgradePrompt-plans'>
                <FlexGrid fillHeight>
                  {plans.map((plan, index) => (
                    <FlexItem spaceLeft={22} spaceRight={22} fillHeight key={`__upgradeprompt_plan_${index}`}>
                      <PlanCard
                        type={plan}
                        overrides={planOverrides[plan]}
                        loading={plan === 'team' && this.state.loading}
                        onCtaClick={() => {
                          if (onPlanClick) return onPlanClick(plan)
                          if (workspace.slug && plan === 'team') changePlan('team-$100-1-month')
                        }} />
                    </FlexItem>
                  ))}
                </FlexGrid>
                <Close className='UpgradePrompt-close' onClick={onClose} />
              </FlexItem>
            </FlexGrid>
          </Animation>
        </div>
      </Overlay>
    )

    function changePlan (planId) {
      this.setState({ loading: true })

      request
        .put(`/api/workspaces/${workspace.slug}/billing/plan`)
        .send({ id: planId })
        .set('x-csrf-token', window.segment.csrf)
        .end(function (err, res) {
          this.setState({
            loading: false,
            error: err || !res.ok
          })

          if (res && res.ok) {
            setTimeout(() => window.location.reload())
          }
        })
    }
  }
}

UpgradePrompt.defaultProps = {
  hasOverlay: true,
  items: [],
  planOverrides: {},
  plans: [],
  workspace: {}
}

UpgradePrompt.displayName = 'UpgradePrompt'

UpgradePrompt.propTypes = {
  hasOverlay: PropTypes.bool.isRequired,
  headline: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onPlanClick: PropTypes.func,
  planOverrides: PropTypes.object.isRequired,
  plans: PropTypes.array.isRequired,
  subhead: PropTypes.string,
  workspace: PropTypes.object.isRequired
}

export default UpgradePrompt



// WEBPACK FOOTER //
// ./ui/UpgradePrompt.js